<template>
  <div id="wrap-drawer">

    <!-- Comments -->
    <comments v-if="comments_on"></comments>

    <!-- Empty -->
    <div v-else-if="route_name=='project'&&proj_docs!==null&&!proj_docs.length" 
      class="container-drawer">
      
      <div id="empty-drawer">
        <div class="empty-contents-title">
          {{ $t('doc_list.empty_title') }}
        </div>
        <div class="empty-contents-meta">
          {{ $t('doc_list.empty_meta_1') }}
        </div>
        <div>
          <v-btn @click="showAddDocuments()"
            depressed dark color="#536BFF">
            <v-icon>mdi-plus</v-icon>
            <span>{{ $t('doc_list.add_documents') }}</span>
          </v-btn>
        </div>
      </div>

    </div>

    <div v-else-if="route_name=='watching-project'&&watching_proj_docs!==null&&!watching_proj_docs.length" 
      class="container-drawer">
      <div id="empty-drawer">
        <div class="empty-contents-title">
          공유 프로젝트에 도큐먼트가 없습니다.
        </div>
        <div class="empty-contents-meta">
          프로젝트 소유자가 도큐먼트를 추가하면 리스트가 나타납니다.
        </div>
        <div>
          <v-btn @click="$router.push({ name: 'watching-project', query: { comments: 'true' } })"
            depressed dark color="primary">
            <span>소유자에게 코멘트 남기기</span>
          </v-btn>
        </div>
      </div>
    </div>

    <!-- Container -->
    <div v-else class="container-drawer">
      <div id="header-drawer">

        <div id="title-drawer">
          <div v-if="!!doc" id="title-drawer-doc">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn fab x-small depressed v-on="on" v-if="!!vid"
                  @click="$router.push({name: route_name, query: { vid }})">
                  <v-icon small>mdi-format-list-bulleted</v-icon>
                </v-btn>
                <v-btn fab x-small depressed v-on="on" v-else
                  @click="$router.push({name: route_name, query: null })">
                  <v-icon small>mdi-format-list-bulleted</v-icon>
                </v-btn>
              </template>
              <span>리스트로 돌아가기</span>
            </v-tooltip>
            <div>도큐먼트 상세</div>
          </div>
          <div v-if="!doc&docs_mode==0">{{ $t('doc_list.in_project') }}</div>
          <div v-if="!doc&docs_mode==1">{{ $t('doc_list.in_tree') }}</div>
          <div v-if="!doc&docs_mode==2">추천 도큐먼트</div>
          <div v-if="!doc&docs_mode==3">도큐먼트 목록</div>
        </div>

        <div id="tab-drawer">
          <div class="tab">
            <v-btn v-if="!!doc&&proj_keys.includes(doc)"
              fab outlined dark x-small color="primary"
              @click="docs_mode=0;$router.push({name: route_name, query: null })">P</v-btn>
            <v-btn v-else-if="!doc&&docs_mode==0" 
              fab dark depressed x-small color="primary">P</v-btn>
            <v-btn v-else fab text x-small 
              @click="docs_mode=0;$router.push({name: route_name, query: null })">P</v-btn>
          </div>
          <div v-if="!!vertex_docs" class="tab">
            <v-btn v-if="!!doc&&tree_keys.includes(doc)" 
              fab dark outlined x-small color="primary"
              @click="docs_mode=1;$router.push({name: route_name, query: null })">T</v-btn>
            <v-btn v-else-if="!doc&&docs_mode==1" 
              fab dark depressed x-small color="primary">T</v-btn>
            <v-btn v-else fab text x-small 
              @click="docs_mode=1;$router.push({name: route_name, query: null })">T</v-btn>
          </div>
          <div v-if="!!sg_keys.length" class="tab">
            <v-btn v-if="!!doc&&sg_keys.includes(doc)" 
              fab dark outlined x-small color="primary"
              @click="docs_mode=2;$router.push({name: route_name, query: null })">S</v-btn>
            <v-btn v-else-if="!doc&&docs_mode==2" 
              fab dark depressed x-small color="primary">S</v-btn>
            <v-btn v-else fab text x-small 
              @click="docs_mode=2;$router.push({name: route_name, query: null })">S</v-btn>
          </div>
          <div v-if="!!vid" class="tab">
            <v-btn v-if="!!doc" 
              fab dark outlined x-small color="primary"
              @click="docs_mode=3;$router.push({name: route_name, query: { vid }})">L</v-btn>
            <v-btn v-else fab dark depressed x-small color="primary" 
              @click="docs_mode=3;$router.push({name: route_name, query: { vid }})">L</v-btn>
          </div>
        </div>

      </div>

      <drawer-list v-show="!doc" :docs_mode="docs_mode"></drawer-list>
      <drawer-doc v-if="!!doc"></drawer-doc>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  props: {
    comments_on: {
      type: Boolean,
      required: true,
    }
  },

  data() {
    return {
      docs_mode: 0,
    }
  },

  computed: {
    ...mapGetters({
      project_info: 'project/project_info',
      proj_docs: 'project/documents',
      watching_proj_docs: 'watching/documents',
      vertex_library: 'tree/vertex_library',
      vertex_docs: 'tree/documents',
      on_sg: 'tree/on_sg',
      sg_keys: 'tree/sg_keys',
    }),

    route_name() {
      return this.$route.name
    },

    proj_id() {
      return this.$route.params.id
    },

    doc() {
      return this.$route.query.doc
    },

    vid() {
      return this.$route.query.vid
    },

    proj_keys() {
      return this.route_name == 'watching-project' ?
        this.watching_proj_docs.map(v => v.key) :
        this.proj_docs.map(v => v.key)
    },

    tree_keys() {
      return this.vertex_docs.map(v => v.doc_key)
    },

    is_inactive() {
      return this.project_info.status >= 10
    },
  },

  watch: {
    vid: {
      handler(val) {
        if (!!val) {
          let ids = Object.values(this.vertex_library).map(v => v.vid)
          if (!ids.includes(val)) {
            this.$router.push({ name: this.route_name, query: null })
            this.docs_mode = 0
          } else {
            this.docs_mode = 3
          }
        }
      },
      immediate: true,
    },

    on_sg(val) {
      if (val) { this.docs_mode = 2 }
      else { this.docs_mode = 0 }
    },
  },

  methods: {
    ...mapMutations({
      showExpiredModal: 'modal/showExpired',
      showAddDocumentsModal: 'modal/showAddDocuments',
    }),

    showAddDocuments() {
      if (this.is_inactive) {
        this.showExpiredModal()
      } else {
        this.showAddDocumentsModal()
        this.$analytics.logEvent('click', { name: 'project_btn_openAddDocuments' })
      }
    },
  },

}
</script>

<style scoped>
  #wrap-drawer {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }

  .container-drawer {
    height: calc(100vh - 60px);
  }

  #empty-drawer {
    background-color: rgba(237, 237, 237);
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid #ededed !important;
    padding: 32px;
  }

  .empty-contents-title {
    font-size: 20px;
    padding-bottom: 20px;
  }

  .empty-contents-meta {
    font-size: 14px;
    padding-bottom: 20px;
    color: rgb(0, 0, 0, .4);
  }

  /* Header */

  #header-drawer {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
    font-size: 16px;
    font-weight: 600;
  }

  #title-drawer {
    width: 140px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #title-drawer-doc {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #title-drawer-doc button {
    margin-right: 8px;
  }

  #tab-drawer {
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 30px;
  }

  .tab {
    margin-right: 8px;
  }

</style>


// WEBPACK FOOTER //
// src/components/shared_components/drawer/Drawer.vue